import addEditRecord from 'add_edit_modals'

export default ({ contact, onSuccess, onClose }) => {
  const deal = {
    name: contact.company_name,
    add_contact_ids: contact.id,
    company_id: contact.company_id,
    company_name: contact.company_name,
    source_id: contact.lead_source_id
  }

  addEditRecord({ resourceType: 'deal', values: deal, formMeta: { onSuccess, onClose } })
}
